// Cabecera del centro — "¿Quién necesita atención ahora?" en ~5s. Sin aritmética exhaustiva ni KPIs técnicos.
import { Users, AlertTriangle, UserCheck, ShieldAlert, Clock } from "lucide-react";

function Stat({ n, label, tone, icon: Icon, testId, title }) {
  return (
    <div data-testid={testId} title={title} className="flex items-center gap-2.5">
      <span className={`flex h-10 w-10 items-center justify-center rounded-xl ${tone}`}><Icon className="h-5 w-5" /></span>
      <div className="leading-none">
        <p className="text-2xl font-extrabold tabular-nums text-[#012472]">{n}</p>
        <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-slate-500">{label}</p>
      </div>
    </div>
  );
}

export default function CentroHeader({ sitio, header }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-x-8 gap-y-3">
      <div className="min-w-0">
        <h1 data-testid="centro-nombre" className="text-2xl font-extrabold tracking-tight text-[#012472]">{sitio.nombre}</h1>
        {(sitio.direccion || sitio.ciudad) && <p className="text-sm text-slate-500">{[sitio.direccion, sitio.ciudad].filter(Boolean).join(", ")}</p>}
      </div>
      <div className="flex flex-wrap items-center gap-6">
        {/* UI-01D · el Radar cuenta PERSONAS; Central cuenta CASOS. La etiqueta lo dice para que
            los dos tableros no se lean como el mismo número. Sin cambios de cálculo. */}
        <Stat n={header.total} label="Residentes" tone="bg-[#012472]/10 text-[#012472]" icon={Users} testId="centro-stat-total" />
        <Stat n={header.requieren} label="Personas con casos pendientes" title="Residentes con al menos un caso sin tomar. Una persona puede tener más de un caso."
          tone="bg-[#FE6A55]/15 text-[#FE6A55]" icon={AlertTriangle} testId="centro-stat-requieren" />
        <Stat n={header.enAtencion} label="Personas en atención" title="Residentes con al menos un caso ya tomado y en curso."
          tone="bg-[#01CBE3]/15 text-[#0891A6]" icon={UserCheck} testId="centro-stat-atencion" />
        {/* v2.14.0 — ACTIVIDAD RECIENTE (ventana de 30 min): es CONTEXTO, no crea casos. Sólo se
            pinta cuando la superficie aporta el dato (Radar Operativo Institucional). */}
        {Number.isFinite(header.actividadReciente) && (
          <Stat n={header.actividadReciente}
            label={`Actividad reciente · ${header.ventanaActividadMin || 30} min`}
            title={`Residentes con actividad observada en los últimos ${header.ventanaActividadMin || 30} minutos. Es contexto: no crea casos.`}
            tone="bg-[#0284C7]/12 text-[#0284C7]" icon={Clock} testId="centro-stat-actividad" />
        )}
        {/* RADAR-002: si falló la consulta de cobertura el contador NO se afirma vigente (ni 0). */}
        <Stat n={header.coberturasHistoricas ? "—" : header.coberturasRevisar}
          label={header.coberturasHistoricas ? "Cobertura de equipos · sin confirmar" : "Cobertura de equipos a revisar"}
          title={header.coberturasHistoricas ? "No se pudo consultar la cobertura: el conteo mostrado no se puede confirmar." : "Capacidades de monitoreo interrumpidas. Cuenta EQUIPOS/capacidades, no casos de persona."}
          tone={header.coberturasHistoricas ? "bg-slate-200 text-slate-500" : "bg-[#9B2C2C]/12 text-[#9B2C2C]"}
          icon={ShieldAlert} testId="centro-stat-cobertura" />
      </div>
    </div>
  );
}
